setTimeout(() => {
  const articleBodyClass = 'article__content--inside'; // クラスを指定
  const tableOfContentsItemProp = 'tableOfContents';

  // ヘッダーの高さを取得する関数
  const getHeaderHeight = () => {
    const header = document.querySelector('.header__inner');
    return header ? header.offsetHeight : 0;
  };

  const getArticleBody = () => {
    return document.querySelector(`.${articleBodyClass}`);
  };

  const getHeadings = () => {
    const articleBody = getArticleBody();
    if (!articleBody) return null;
    return articleBody.querySelectorAll('h2, h3, h4');
  };

  const existsTableOfContents = () => {
    return !!document.querySelector(`[itemprop="${tableOfContentsItemProp}"]`);
  };

  const generateAnchor = (id) => {
    const anchor = document.createElement('a');
    anchor.style.display = 'block';
    anchor.style.width = '100%';
    anchor.style.padding = 0;
    anchor.style.margin = 0;
    anchor.style.lineHeight = '21px';
    anchor.style.fontSize = '14px';
    anchor.style.color = '#6f7372';
    const content = document.createTextNode(id);
    anchor.appendChild(content);

    anchor.addEventListener('click', (event) => {
      event.preventDefault();
      const target = document.getElementById(id);
      if (target) {
        const headerHeight = getHeaderHeight();
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: targetPosition - headerHeight, // ヘッダーの高さ分スクロール位置を調整
          behavior: 'smooth'
        });
      }
    });
    
    anchor.setAttribute('href', `#${id}`);
    return anchor;
  };

  const generateListItem = (id, tagName) => {
    const listItem = document.createElement('li');
    listItem.style.padding = '8px 0';
    listItem.style.margin = 0;
    listItem.style.listStyleType = 'none';
    if (tagName === 'H3') {
      listItem.style.paddingLeft = '24px';
    } else if (tagName === 'H4') {
      listItem.style.paddingLeft = '36px';
    }
    const anchor = generateAnchor(id);
    listItem.appendChild(anchor);
    return listItem;
  };

  const generateList = (headings) => {
    if (!headings) return;
    const list = document.createElement('ul');
    list.style.padding = 0;
    list.style.margin = '16px 0 0';
    list.style.listStyle = 'none';
    Array.prototype.forEach.call(headings, (heading) => {
      const listItem = generateListItem(
        heading.id,
        heading.tagName
      );
      list.appendChild(listItem);
    });
    return list;
  };

  const generateTitle = () => {
    const title = document.createElement('h2');
    title.style.fontSize = '14px';
    title.style.fontWeight = '700';
    title.style.margin = 0;
    title.style.color = 'rgb(111, 115, 114)';
    title.style.lineHeight = 1.5;
    title.style.letterSpacing = '0.04em';
    const content = document.createTextNode('目次');
    title.appendChild(content);
    return title;
  };

  const generateTableOfContents = (headings) => {
    if (!headings) return;
    const tableOfContents = document.createElement('nav');
    tableOfContents.setAttribute('itemprop', tableOfContentsItemProp);
    tableOfContents.style.padding = '16px';
    tableOfContents.style.margin = '36px 0';
    tableOfContents.style.backgroundColor = '#f7f9f9';
    const title = generateTitle();
    tableOfContents.appendChild(title);
    const list = generateList(headings);
    tableOfContents.appendChild(list);
    return tableOfContents;
  };

  const addIdToHeading = () => {
    const headings = getHeadings();
    if (!headings) return;
    Array.prototype.forEach.call(headings, (heading) => {
      heading.id = heading.textContent.trim();
    });
  };

  const addTableOfContents = () => {
    const articleBody = getArticleBody();
    const headings = getHeadings();
    if (!articleBody || !headings || !headings.length) return;
    const tableOfContents = generateTableOfContents(headings);
    if (!tableOfContents) return;
    if (existsTableOfContents()) return;

    // 目次を記事コンテンツの一番上に追加
    articleBody.insertBefore(tableOfContents, articleBody.firstChild);
  };

  addIdToHeading();
  addTableOfContents();
}, 500); // 500ms 遅延させる
